import { FC } from 'react'
import clsx from 'clsx'
import { Typography } from '@mui/material'
import { Image } from '../../../image/Image'
import { getItemUrl, renderLabel } from '../../../inline-media-box/helpers'
import { ContentItem } from '@obeta/data/lib/hooks/useArticleGalleryContent'
import styles from './MediaItemsSection.module.scss'

type MediaItemsGridProps = {
  title?: string | null
  items: ContentItem[]
  onSetPreview: (itemIdx: number) => void
  activeItemIndex: number
}

export const MediaItemsGrid: FC<MediaItemsGridProps> = ({
  title,
  items,
  onSetPreview,
  activeItemIndex,
}) => {
  if (items.length === 0) return null

  return (
    <div
      className={clsx(styles.mediaItemsPanelDesktopViewSection, {
        [styles.halfView]: items.length === 1,
      })}
    >
      <div className={styles.sectionContent}>
        {title && (
          <div className={styles.sectionTitle}>
            <Typography variant="bodyBold">
              {title} {items.length > 1 ? `(${items.length})` : ''}
            </Typography>
          </div>
        )}

        <div className={styles.contentItems}>
          {items.map((mediaItem) => {
            const isActive = activeItemIndex === mediaItem.itemIndex

            const contentTypeLabel = renderLabel(mediaItem)

            return (
              <div
                key={mediaItem.itemIndex}
                className={clsx(styles.mediaItemContainer, { [styles.isActive]: isActive })}
                onClick={() => onSetPreview(mediaItem.itemIndex)}
              >
                <Image
                  variant="product"
                  src={getItemUrl(mediaItem)}
                  alt={mediaItem.description}
                  className={clsx(
                    styles.mediaItemsPanelDesktopViewImage,
                    contentTypeLabel && styles.semiTransparent
                  )}
                />
                {contentTypeLabel}
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
